import { useMount } from '@tiger/hooks';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/base/Button';
import AgreementInfo from 'components/forms/AgreementInfo';
import { getFullName } from 'components/forms/RealNameInfo';
import Toast from 'components/Toast';
import security from 'stores/security';
import values from 'stores/values';
import { CategoryEnum, CustomerInfoType, IdTypeEnum, LicenseEnum } from 'types/customer';
import { reportEventList } from 'utils/gtag';
import { getOpenType, openAccount } from 'utils/request';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import { handleBackEsop } from '../helper';

const Agreements: React.FC<ProgressFormProps> = ({ onSubmit }) => {
    const navigate = useNavigate();
    const [license, setLicense] = useState<LicenseEnum>(LicenseEnum.MARSCO);
    const storageInfo = values.getParams<CustomerInfoType>();
    const { account_capabilities: accountCapability, opt_perm } = storageInfo;
    const name = getFullName(storageInfo);

    const getLicense = async () => {
        Toast.loading(true, __('Loading'));

        try {
            const res = await getOpenType();

            res.data[0] && setLicense(res.data[0].license || LicenseEnum.MARSCO);
        } catch (error) {
            Toast.show(error);
        }

        Toast.loading(false);
    };

    useMount(() => {
        getLicense();
    });

    const handleSubmit = (ev: React.FormEvent) => {
        onSubmit(async () => {
            Toast.loading(true, __('Loading'));

            reportEventList('agreement');

            try {
                const params = values.getParams();

                params.account_type = 'ib';
                params.tax_residence_country = 'USA';
                params.tax_identification_number = params.id_no;
                params.id_type = IdTypeEnum.SSN_IDS;
                params.source = 'esop';

                params.legal_residence_country = 'USA'; // 新版填写移除 写死传入USA
                params.base_currency = 'USD'; // 新版必传入项
                params.clearing = 'marsco';

                // 暂时只有 Marsco 为券商
                params.license = license;

                const { customer_id } = await openAccount(params);

                // 开户资料提交后需要获取用户状态信息(用户的statusCode有变化)
                try {
                    await security.getOpenProcess(customer_id);

                    values.clear();

                    let path = '/esop/signup/complete';

                    if (customer_id) {
                        path = `/esop/${customer_id}/signup/complete`;
                    }

                    navigate(path);
                } catch (error) {
                    handleBackEsop(__('System Error'), error.message);
                }
            } catch (error) {
                Toast.show(error);
            }

            Toast.loading(false);
        }, ev);
    };

    return (
        <form noValidate className="open-agreement-root" onSubmit={handleSubmit}>
            <AgreementInfo
                category={CategoryEnum.INDIVIDUAL}
                license={license}
                name={name}
                accountCapability={accountCapability}
                perms={{ opt_perm }}
            />
            <Button block type="primary" size="lg" htmlType="submit">
                {__('Submit')}
            </Button>
        </form>
    );
};

export default withProgressForm({
    id: 'agreements',
    step: 6,
    ensure: ['baseinfo', 'job', 'invest'],
    basePath: 'esop'
})(Agreements);
